import { useNavigateWithParams } from 'core/hooks/useNavigateWithParams';

export const IncidentDetailPageLayout = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const navigateWithParams = useNavigateWithParams();

  // 事案一覧に戻る
  const handleBackToList = () => {
    navigateWithParams('/jian-list');
  };

  return (
    <div className="container mx-auto px-4">
      <button
        className="flex items-center text-primary hover:text-primary-dark transition-colors duration-200"
        onClick={handleBackToList}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="w-5 h-5 mr-2"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15.75 19.5L8.25 12l7.5-7.5"
          />
        </svg>
        <span className="text-base font-medium">事案一覧に戻る</span>
      </button>
      <div className="mt-6 flex flex-col m-auto">{children}</div>
    </div>
  );
};
